

export const ActionTypes = {
	SET_FRONTEND_PROJECTS: 'SET_FRONTEND_PROJECTS',
	SET_BACKEND_PROJECTS: 'SET_BACKEND_PROJECTS',
	SET_VANILLAJS_PROJECTS: 'SET_VANILLAJS_PROJECTS',
	SET_WEB_DESIGN_PROJECTS: 'SET_WEB_DESIGN_PROJECTS',
	SET_MAIN_PROJECTS: 'SET_MAIN_PROJECTS',
	SET_ALL_PROJECTS: 'SET_ALL_PROJECTS',
	SET_MAIN_TAGS: 'SET_MAIN_TAGS',
	SET_TAG_COUNT: 'SET_TAG_COUNT',
	SET_SELECTED_SECTION: 'SET_SELECTED_SECTION',
};


